import React from 'react';

// Make group for face '.fill--face'
// Make glasses target 'ref="glassesTarget"'
// Make groups for each eye group
// - '.fill-eyes eyes'
// - '.fill-face eyes--blink'
// - '.fill-face eyes--is-being-pet--likes'
// - '.fill-eyes eyes--is-being-pet--hates'

export default class Eyes extends React.Component {
	componentDidMount() {
		this.props.getGlassesTargetCoords(this.refs.glassesTarget);
	}
	render() {
		return (
			<g className="fill--face">
				<circle ref="glassesTarget" cx="105.9212341" cy="291.245575" r="0" />
				<g className="fill--eyes eyes">
					<path d="M97.9024353,291.245575c0,3.4293823-2.2626648,5.4797974-5.0537949,5.4797974s-5.0537872-2.050415-5.0537872-5.4797974
						c0-3.4293518,2.2626572-5.4797974,5.0537872-5.4797974S97.9024353,287.8162231,97.9024353,291.245575z" />
					<path d="M124.037941,291.245575c0,3.4293823-2.2626648,5.4797974-5.0537949,5.4797974s-5.0537872-2.050415-5.0537872-5.4797974
						c0-3.4293518,2.2626572-5.4797974,5.0537872-5.4797974S124.037941,287.8162231,124.037941,291.245575z" />
				</g>
				<g className="fill--face eyes--blink">
					<path d="M114.067009,294.1382141c-0.7614365-0.0583801-1.3980713-0.6508484-1.485054-1.4377136
						c-0.0987854-0.8897095,0.5425262-1.6912231,1.4322357-1.7900085l10.0128632-1.1112061
						c0.8896637-0.0981445,1.6915283,0.542572,1.7896576,1.4325256c0.0987854,0.8897095-0.5425262,1.6912231-1.4322357,1.7900085
						l-10.0128632,1.1112061C114.268486,294.1444702,114.1667633,294.145874,114.067009,294.1382141z" />
					<path d="M97.7736435,294.1382141c0.7614365-0.0583801,1.3980713-0.6508484,1.485054-1.4377136
						c0.0987854-0.8897095-0.5425262-1.6912231-1.4322357-1.7900085l-10.0128632-1.1112061
						c-0.8896637-0.0981445-1.6915283,0.542572-1.7896576,1.4325256c-0.0987854,0.8897095,0.5425262,1.6912231,1.4322357,1.7900085
						l10.0128632,1.1112061C97.5721664,294.1444702,97.6738892,294.145874,97.7736435,294.1382141z" />
				</g>
				<g className="fill--face eyes--is-being-pet--likes">
					<path d="M114.1315002,294.1550903c-0.4378662-0.0168152-0.8670731-0.2097473-1.1732712-0.5697327
						c-0.5802765-0.6819153-0.4972839-1.7050171,0.1846466-2.2849731c1.3743439-1.1690063,3.4913406-1.8583069,5.8081055-1.8910828
						c2.3187027-0.0339355,4.4528275,0.5973816,5.8593216,1.7279968c0.6977081,0.5609741,0.8087311,1.5813599,0.2477493,2.2790833
						c-0.5616226,0.697998-1.5816345,0.8077698-2.2787628,0.2480774c-0.6300812-0.5067444-1.9481354-1.0357666-3.7828979-1.0133362
						c-1.8272858,0.0258789-3.1367874,0.5950317-3.7531967,1.1188965
						C114.9209061,294.0440674,114.5231781,294.1701355,114.1315002,294.1550903z" />
					<path d="M97.7091522,294.1550903c0.4378662-0.0168152,0.8670731-0.2097473,1.1732712-0.5697327
						c0.5802689-0.6819153,0.4972839-1.7050171-0.1846466-2.2849731c-1.3743439-1.1690063-3.4913406-1.8583069-5.8081055-1.8910828
						c-2.3187103-0.0339355-4.4528275,0.5973816-5.8593216,1.7279968c-0.6977081,0.5609741-0.8087311,1.5813599-0.2477493,2.2790833
						c0.5616226,0.697998,1.5816345,0.8077698,2.2787628,0.2480774c0.6300812-0.5067444,1.9481354-1.0357666,3.7828979-1.0133362
						c1.8272858,0.0258789,3.1367874,0.5950317,3.7531967,1.1188965
						C96.9197464,294.0440674,97.3174744,294.1701355,97.7091522,294.1550903z" />
				</g>
				<g className="fill--eyes eyes--is-being-pet--hates">
					<path d="M124.0476151,291.245575c0,3.4293823-2.2626572,5.4797974-5.0537872,5.4797974s-5.0537872-2.050415-5.0537872-5.4797974
						c0-1.8418579,2.2626572-1.8375549,5.0537872-1.8375549S124.0476151,289.403717,124.0476151,291.245575z" />
					<path d="M87.7930374,291.245575c0,3.4293823,2.2626572,5.4797974,5.0537872,5.4797974s5.0537872-2.050415,5.0537872-5.4797974
						c0-1.8418579-2.2626572-1.8375549-5.0537872-1.8375549S87.7930374,289.403717,87.7930374,291.245575z" />
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Tortoise/Eyes.js